import * as yup from 'yup'

export const setPasswordSchema = yup.object({
    password: yup.string().min(8,'Password must be at least 8 characters').matches( /[a-zA-Z]/,
    'Password must contain upper and lower case characters').matches(/\d/, 'Password must have a number')
    .matches(/[!@#$%^&*()\-_=+{};:,<.>]/, 'Password must have a special character').required('Password is required'),
    confirmPassword: yup.string().oneOf([yup.ref('password'),null],'Password must match').required('Please confirm your password')
})